<template>
  <div>
    <Navbar/>
    <h4>Atencion</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencion.idAtencion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoAtencion.idEmpresa" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoAtencion.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoAtencion.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idCita" class="form-label"> Cita</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idCita" name="idCita" v-model="datoAtencion.idCita">
                      <option v-for="cita in citas" :value="cita.idCita" :key="cita.idCita">
                        {{ cita.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFactura" class="form-label"> Factura</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFactura" name="idFactura" v-model="datoAtencion.idFactura">
                      <option v-for="factura in facturas" :value="factura.idFactura" :key="factura.idFactura">
                        {{ factura.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsiento" class="form-label"> Asiento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsiento" name="idAsiento" v-model="datoAtencion.idAsiento">
                      <option v-for="asiento in asientos" :value="asiento.idAsiento" :key="asiento.idAsiento">
                        {{ asiento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoAtencion.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoAtencion.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAtencion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoAtencion.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoAtencion.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMotivo" class="form-label"> Motivo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMotivo" name="idMotivo" v-model="datoAtencion.idMotivo">
                      <option v-for="motivo in motivos" :value="motivo.idMotivo" :key="motivo.idMotivo">
                        {{ motivo.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtencion" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtencion" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAtenObst</th>
          <th scope="col">IdAtencion</th>
          <th scope="col">IdAnticonceptivo</th>
          <th scope="col">ViveSola</th>
          <th scope="col">LugControl</th>
          <th scope="col">LugParto</th>
          <th scope="col">Peso</th>
          <th scope="col">Talla</th>
          <th scope="col">Fpp</th>
          <th scope="col">Fum</th>
          <th scope="col">ConsejeriaAC</th>
          <th scope="col">Estado</th>
          <th scope="col">AtencionFechaReg</th>
          <th scope="col">AnticonceptivoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="atenobst in datosPaginados" :key="atenobst.idAtenObst">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(atenobst.idAtenObst)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(atenobst.idAtenObst)" title="Editar">edit_square</i></td>
          <td>{{atenobst.idAtenObst}}</td>
          <td>{{atenobst.idAtencion}}</td>
          <td>{{atenobst.idAnticonceptivo}}</td>
          <td>{{atenobst.viveSola}}</td>
          <td>{{atenobst.lugControl}}</td>
          <td>{{atenobst.lugParto}}</td>
          <td>{{atenobst.peso}}</td>
          <td>{{atenobst.talla}}</td>
          <td>{{getFormattedDate(atenobst.fpp, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(atenobst.fum, 'DD/MM/YYYY')}}</td>
          <td>{{atenobst.consejeriaAC}}</td>
          <td>{{atenobst.estado}}</td>
          <td>{{getFormattedDate(atenobst.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{atenobst.anticonceptivoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAtencion(atenobst.idAtenObst)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAtenObst" class="form-label">IdAtenObst</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtenObst" name="idAtenObst" v-model="datoAtenObst.idAtenObst" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAtencion" class="form-label">IdAtencion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtenObst.idAtencion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAnticonceptivo" class="form-label"> Anticonceptivo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAnticonceptivo" name="idAnticonceptivo" v-model="datoAtenObst.idAnticonceptivo">
                      <option v-for="anticonceptivo in anticonceptivos" :value="anticonceptivo.idAnticonceptivo" :key="anticonceptivo.idAnticonceptivo">
                        {{ anticonceptivo.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="viveSola" class="form-label">ViveSola</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="viveSola" name="viveSola" v-model="datoAtenObst.viveSola" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="lugControl" class="form-label">LugControl</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="lugControl" name="lugControl" v-model="datoAtenObst.lugControl" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="lugParto" class="form-label">LugParto</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="lugParto" name="lugParto" v-model="datoAtenObst.lugParto" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="peso" class="form-label">Peso</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="peso" name="peso" v-model="datoAtenObst.peso" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="talla" class="form-label">Talla</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="talla" name="talla" v-model="datoAtenObst.talla" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fpp" class="form-label">Fpp</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fpp" name="fpp" v-model="datoAtenObst.fpp" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fum" class="form-label">Fum</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fum" name="fum" v-model="datoAtenObst.fum" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="consejeriaAC" class="form-label">ConsejeriaAC</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="consejeriaAC" name="consejeriaAC" v-model="datoAtenObst.consejeriaAC" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtenObst" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtenObst" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      atencions : [],
      datoAtencion : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAtencion: '',
      personas : [],
      medicos : [],
      citas : [],
      facturas : [],
      asientos : [],
      motivos : [],
// Variables master
// Variables details
      atenobsts : [],
      datoAtenObst : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
//      atencions : [],
      anticonceptivos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idAtencion = this.$route.params.p_idatencion
    this.abrirEditar(this.p_idAtencion)
    this.getDataPagina(this.paginaActual)
    this.fetchPersonas()
    this.fetchMedicos()
    this.fetchCitas()
    this.fetchFacturas()
    this.fetchAsientos()
    this.fetchMotivos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idPersona'
        ,'idMedico'
        ,'idCita'
        ,'idFactura'
        ,'idAsiento'
        ,'observacion'
        ,'idMotivo'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idPersona'
        ,'idMedico'
        ,'idCita'
        ,'idFactura'
        ,'idAsiento'
        ,'observacion'
        ,'idMotivo'
      ];
      return validarForm(this.datoAtencion, requiredFields, requiredFieldsText);
    },
    async guardarAtencion(){
      if(this.validarForm() === 1){
        try {
          this.datoAtencion.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/atencions', this.datoAtencion)
          swal("Correcto!", "Atencion creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtencion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atencions', this.datoAtencion)
          swal("Correcto!", "Atencion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAtencion={}
      this.titulo   = 'Crear Atencion'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAtencion){
      this.modalWindow = true
      if(idAtencion != null){    
           api.get('/vwatencions/'+idAtencion).then(resp=>{
          this.datoAtencion = resp.data;
           });
      }
      this.titulo   = 'Editar Atencion'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAtencion(){
      this.$router.push('/Atencion')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.atenobsts.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwatenobsts/nombre/'+this.nombreBusqueda).then(response=>{
          this.atenobsts=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.atenobsts.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwatenobsts').then(response=>{
      this.atenobsts=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.atenobsts.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idPersona'
        ,'idMedico'
        ,'idCita'
        ,'idFactura'
        ,'idAsiento'
        ,'observacion'
        ,'idMotivo'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'idPersona'
        ,'idMedico'
        ,'idCita'
        ,'idFactura'
        ,'idAsiento'
        ,'observacion'
        ,'idMotivo'
      ];
      return validarForm(this.datoAtencion, requiredFields, requiredFieldsText);
    },
    async guardarAtenObst(){
      if(this.validarForm() === 1){
        try {
          this.datoAtenObst.idAtencion = this.datoAtencion.idAtencion;
          await api.post('/atenobsts', this.datoAtenObst)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AtenObst creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtenObst(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atenobsts', this.datoAtenObst)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AtenObst creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAtenObst={}
      this.titulo   = 'Crear Atencion'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAtenObst){
      this.modalWindow = true
      if(idAtenObst != null){    
           api.get('/vwatenobsts/'+idAtenObst).then(resp=>{
          this.datoAtenObst = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Atencion'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAtenObst){
      this.modalWindow = true
      if(idAtenObst != null){
        this.$router.push('/atenobstmd/'+idAtenObst)
      }
    },
    async deleteAtenObst (idAtenObst) {
      try{
        await api.delete('/atenobsts/'+idAtenObst)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
    fetchCitas() {
      fetch('http://localhost:8080/api/v1/citas')
        .then(response => response.json())
        .then(data => {
          this.citas = data;
        })
        .catch(error => {
          console.error('Error fetching citas:', error);
        });
    },
    fetchFacturas() {
      fetch('http://localhost:8080/api/v1/facturas')
        .then(response => response.json())
        .then(data => {
          this.facturas = data;
        })
        .catch(error => {
          console.error('Error fetching facturas:', error);
        });
    },
    fetchAsientos() {
      fetch('http://localhost:8080/api/v1/asientos')
        .then(response => response.json())
        .then(data => {
          this.asientos = data;
        })
        .catch(error => {
          console.error('Error fetching asientos:', error);
        });
    },
    fetchMotivos() {
      fetch('http://localhost:8080/api/v1/motivos')
        .then(response => response.json())
        .then(data => {
          this.motivos = data;
        })
        .catch(error => {
          console.error('Error fetching motivos:', error);
        });
    },
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchAnticonceptivos() {
      fetch('http://localhost:8080/api/v1/anticonceptivos')
        .then(response => response.json())
        .then(data => {
          this.anticonceptivos = data;
        })
        .catch(error => {
          console.error('Error fetching anticonceptivos:', error);
        });
    },
  },
}
</script>
